(function() {
    'use strict';

    angular
        .module('portalApp')
        .factory('TimeseriesSearch', TimeseriesSearch);

    TimeseriesSearch.$inject = ['$resource'];

    function TimeseriesSearch($resource) {
        var resourceUrl =  'api/_search/timeseries/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
